import { actionTypes } from "./constants";
const initialState = {
  isLogin: false,
  loginToken: '',
  companyInfo: null,
  managerAccount: {
    id: '',
    fullname: '',
    username: '',
    dept: '',
    phone: '',
    email: '',
    worknum: '',
    discount: '',
  },
  userInfo: {
    id: '',
    username: '',
    roleName: '',
    phone: '',
    state: '', // 'REGISTER','AUDITFAIL','FORMAL','FREEZE','DELETE','AUDITING'
    privileges: [],
    category: 'ADMIN',// 超级管理员:'ADMIN', 渠道经理人员:'SALE', 代理商: 'AGENT,
    agentUserId: 0, // 
    discount: 100,
    level: {},
  },
  vcode: {
    vkey:'',
    img:''
  },
  userAuditNoticeTag: false,
  allProductManager: [],
  allProductManagerFormat: [],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.USER_LOGIN:
      return {
        ...state, userInfo: action.data, isLogin: true,
      };
    case actionTypes.SET_LOGIN_TOKEN:
      return {
        ...state, loginToken: action.data,
      };
    case actionTypes.SET_MANAGER_ACCOUNT:
      return {
        ...state, managerAccount: action.data,
      };
    case actionTypes.SET_COMPANY_INFO:
      return {
        ...state, companyInfo: action.data,
      };
    case actionTypes.LOGOUT:
      return {
        ...state, isLogin: false, token: '', userInfo: {
          id: '',
          category: '',
          username: '',
          state: '',
          roleName: '',
          privileges: [],
          phone: '',
          type: '',
        }, loginToken: ''
      };
    case actionTypes.SET_VCODE:
      return {
        ...state,vcode: action.data
      };
    case actionTypes.SET_USER_AUDIT_NOTICE_TAG:
      return {
        ...state,userAuditNoticeTag: action.data
      };
    case actionTypes.SET_USER_INFO:
      return {
        ...state, userInfo: { ...state.userInfo, ...action.data },
      };
    case actionTypes.SET_ALL_PRODUCT_MANAGER:
      return {
        ...state, allProductManager: action.data,
      };
    case actionTypes.SET_ALL_PRODUCT_MANAGER_FORMAT:
      return {
        ...state, allProductManagerFormat: action.data,
      };
    default:
      return state;
  }
};